<template>
  <v-row dense>
    <v-col cols="6">
      <v-text-field
        v-model.number="form.quantity_of_days"
        name="quantity_of_days"
        :readonly="readonly"
        :label="$t('REQUEST_VACATIONS.APPROVED_DAYS')"
        :rules="getRulesByName('quantity_of_days')"
        :error-messages="errors.quantity_of_days"
        type="number"
        step="0.5"
        min="0"
        @input="updateValue('quantity_of_days', $event)"
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-textarea
        v-model="form.internal_note"
        name="info"
        outlined
        :label="$t('REQUEST_VACATIONS.INTERNAL_NOTE')"
        :counter="1000"
        :readonly="readonly"
        :rules="getRulesByName('internal_note')"
        :error-messages="errors.internal_note"
        @input="updateValue('internal_note', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';
import {
  isNumeric,
  maxLength,
  minNumeric,
  notEmoji,
  positiveNumber
} from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';

export default {
  name: 'RequestVacationEditForm',

  filters: {
    dateFormat
  },

  components: {},

  mixins: [formEditable],

  data() {
    return {
      form: {
        quantity_of_days: 0
      },
      rules: {
        internal_note: [maxLength(1000), notEmoji],
        quantity_of_days: [isNumeric, positiveNumber, minNumeric(0)]
      }
    };
  },

  computed: {},

  created() {},
};
</script>
